import * as m from "@qpr/client-api-base/api/model";
import memoizee from "memoizee";

export const getModel = memoizee((id: string) => m.getModel(id), {
  //promise: true,
});
